const state = {
  about: [],
  about_id: [],
};

export default state;
